/**
 * Cart Services Sync (Yeppon)
 * Mantiene coerenti le righe servizio col loro prodotto padre:
 *  - padre rimosso -> servizi rimossi (orfani)
 *  - quantita' servizio = quantita' del padre
 *  - righe servizio duplicate per lo stesso (padre, servizio) -> tenuta la prima, azzerate le altre
 *  - pota il marcatore _alp_selected dai prodotti non piu' in carrello
 * Tutte le scritture passano da una catena condivisa (window.__svcCartChain):
 * mai due sync sovrapposte, mai snapshot stale.
 */
(function () {
  'use strict';
  if (window.__svcSyncInstalled) return;
  window.__svcSyncInstalled = true;

  var origFetch = window.fetch.bind(window);

  function chainCart(fn) {
    window.__svcCartChain = (window.__svcCartChain || Promise.resolve()).then(fn).catch(function () {});
    return window.__svcCartChain;
  }

  function doSync() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Riga del prodotto "Servizi Yeppon" senza _parent: succede quando il carrello
        // viene ricostruito senza le property (es. dopo il login, YP-547285 del 01/10).
        // Non e' un prodotto e non si sa a quale padre appartiene: va tolta, altrimenti
        // arriva nell'ordine come riga a se' (doppio addebito, import che si ferma).
        // handle: "servizi-yeppon-1" su yeppon, "servizi-yeppon" su scalapay e b2welfare
        function isServizioSenzaPadre(i) {
          return /^servizi-yeppon(-\d+)?$/.test(i.handle || '') && !(i.properties && i.properties._parent);
        }

        // quantita' totale per prodotto padre (somma delle righe non-servizio)
        var parents = {};
        cart.items.forEach(function (i) {
          if (isServizioSenzaPadre(i)) return;
          if (!(i.properties && i.properties._parent)) {
            var gid = 'gid://shopify/Product/' + i.product_id;
            parents[gid] = (parents[gid] || 0) + i.quantity;
          }
        });

        // codici servizio presenti per prodotto padre (per le regole di dipendenza)
        var codesByParent = {};
        cart.items.forEach(function (i) {
          var p = i.properties && i.properties._parent;
          var c = i.properties && i.properties._svc_code;
          if (p && c) codesByParent[p + '|' + c] = true;
        });

        // servizi: orfano -> 0; duplicato -> 0; altrimenti qty = padre
        var updates = {}, changes = 0, orphanOrDup = 0;
        var seen = {};
        var svcParents = {}, alpParents = {};
        cart.items.forEach(function (i) {
          if (isServizioSenzaPadre(i)) {
            if (i.quantity !== 0) { updates[i.key] = 0; orphanOrDup++; }
            return;
          }
          var p = i.properties && i.properties._parent;
          if (!p) return;
          var code = (i.properties && i.properties._svc_code) || '';
          // installazione a colonna esiste solo insieme all'installazione classica
          if (code === 'KC' && !codesByParent[p + '|INST']) {
            if (i.quantity !== 0) { updates[i.key] = 0; orphanOrDup++; }
            return;
          }
          if (parents[p]) {
            if (code === 'ALP') alpParents[p] = true;
            else svcParents[p] = true;
          }
          var want = parents[p] || 0;
          var key = p + '|' + (code || i.variant_id);
          if (want === 0 || seen[key]) {
            if (i.quantity !== 0) { updates[i.key] = 0; orphanOrDup++; }
            return;
          }
          seen[key] = true;
          if (i.quantity !== want) { updates[i.key] = want; changes++; }
        });

        // rete di sicurezza: un prodotto con servizi presuppone la consegna al piano;
        // se manca la riga-marcatore ALP la aggiungiamo qui (copre upsell/JS vecchi/login)
        var alpToAdd = [];
        Object.keys(svcParents).forEach(function (p) {
          if (!alpParents[p]) {
            alpToAdd.push({
              id: (window.__svcVariants || {}).ALP || '65719443161437',
              quantity: parents[p] || 1,
              properties: { _svc_price: '0.00', _svc_code: 'ALP', _svc_label: 'Consegna al piano e disimballo', _parent: p }
            });
          }
        });
        if (alpToAdd.length) {
          return origFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: alpToAdd })
          }).then(function (res) {
            if (res && res.ok) window.location.reload(); // la sync al reload sistema il resto
          });
        }

        // pota il marcatore consegna al piano dai prodotti non piu' in carrello
        var alpCur = (cart.attributes && cart.attributes._alp_selected) || '';
        var alpNext = alpCur.split(',').filter(function (g) { return g && parents[g]; }).join(',');
        var alpChanged = alpNext !== alpCur;

        if (!orphanOrDup && !changes && !alpChanged) return;
        var body = {};
        if (orphanOrDup || changes) body.updates = updates;
        if (alpChanged) body.attributes = { _alp_selected: alpNext };
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (res) {
          // reload SOLO se l'update e' andato a buon fine (niente loop su errori 4xx/5xx)
          if (res && res.ok && (orphanOrDup || changes)) window.location.reload();
        });
      })
      .catch(function () {});
  }

  function sync() { return chainCart(doSync); }

  // Alcuni browser (estensioni) rendono window.fetch di sola lettura: l'assegnazione
  // lancia e si porterebbe via tutto il resto dello script. Senza patch si va avanti lo stesso.
  var fetchPatch = function (input, opts) {
    var p = origFetch(input, opts);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(change|update|add)/.test(url)) {
        p.then(function () { setTimeout(sync, 250); }, function () {});
      }
    } catch (e) { /* noop */ }
    return p;
  };
  try { window.fetch = fetchPatch; } catch (e) {
    try { Object.defineProperty(window, 'fetch', { value: fetchPatch, configurable: true, writable: true }); } catch (e2) { /* noop */ }
  }

  // rimozione a cascata: togliere la CONSEGNA AL PIANO rimuove anche gli altri
  // servizi del prodotto (la presuppongono) in un solo update + un solo reload.
  // Per gli altri servizi: rimozione singola atomica (via key, niente line-index stale).
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-svc-remove]') : null;
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    var parent = a.getAttribute('data-svc-parent') || '';
    var code = a.getAttribute('data-svc-code') || '';
    chainCart(function () {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (i) {
            var p = i.properties && i.properties._parent;
            if (p !== parent) return;
            var c = (i.properties && i.properties._svc_code) || '';
            // ALP a cascata su tutto; INST porta via anche la colonna (KC)
            if (code === 'ALP' || c === code || (code === 'INST' && c === 'KC')) updates[i.key] = 0;
          });
          if (!Object.keys(updates).length) return;
          return origFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function (res) { if (res && res.ok) window.location.reload(); });
        });
    });
  }, true);

  // Ritiro in sede scelto nel popup (_consegna_scelta = ritiro): al checkout resta solo
  // il ritiro. Chi cambia idea torna qui da /cart?togli_ritiro=1 e la scelta si azzera;
  // si azzera anche a carrello vuoto, per non portarsela dietro in un ordine nuovo.
  function azzeraRitiro() {
    var richiesto = /[?&]togli_ritiro=1/.test(window.location.search);
    chainCart(function () {
      return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var scelta = cart.attributes && cart.attributes._consegna_scelta;
          if (!scelta || !(richiesto || cart.item_count === 0)) return;
          return origFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _consegna_scelta: '' } })
          }).then(function (res) {
            if (!richiesto || !res || !res.ok) return;
            var n = document.createElement('div');
            n.setAttribute('role', 'status');
            n.textContent = 'Ritiro in sede rimosso: al checkout potrai scegliere la consegna.';
            n.style.cssText = 'position:fixed;left:50%;bottom:2.4rem;transform:translateX(-50%);z-index:2147483000;max-width:calc(100vw - 3.2rem);padding:1.2rem 1.8rem;border-radius:1rem;background:#0b5d1e;color:#fff;font-size:1.4rem;font-weight:600;box-shadow:0 .8rem 2.4rem rgba(0,0,0,.25);';
            document.body.appendChild(n);
            setTimeout(function () { n.remove(); }, 7000);
          });
        });
    });
  }

  function avvio() { sync(); azzeraRitiro(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvio);
  else avvio();
})();
